import { render, staticRenderFns } from "./EventModalCatalogManager.vue?vue&type=template&id=31ed60f3&scoped=true"
import script from "./EventModalCatalogManager.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogManager.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogManager.vue?vue&type=style&index=0&id=31ed60f3&prod&lang=scss"
import style1 from "./EventModalCatalogManager.vue?vue&type=style&index=1&id=31ed60f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed60f3",
  null
  
)

export default component.exports